import React from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  const pillars = [{
    icon: '🌿',
    title: 'NATURAL',
    description: 'Ingredientes del Amazonas, sin químicos ni artificiales.'
  }, {
    icon: '🔬',
    title: 'CIENTÍFICO',
    description: 'Fórmulas respaldadas por investigación y biofermentación.'
  }, {
    icon: '💚',
    title: 'EFECTIVO',
    description: 'Sistema completo que trabaja en sinergia dentro de tu cuerpo.'
  }];
  return <section className="py-24 bg-white" data-id="element-382">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-383">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-384">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-385">
            La Naturaleza del Amazonas Tiene la Respuesta
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-386">
            Ingredientes ancestrales + ciencia moderna = resultados reales
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-387">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center p-8 rounded-3xl bg-[#FAFAF7] border border-gray-100" data-id="element-388">
              <div className="text-5xl mb-6 bg-white w-24 h-24 rounded-full flex items-center justify-center shadow-sm border border-gray-50" data-id="element-389">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-bold text-[#1B5E20] mb-3 tracking-wide" data-id="element-390">
                {pillar.title}
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-391">{pillar.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}